import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-nav-tabs-btn as-nav-tabs-btn__border" }
const _hoisted_2 = { class: "as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }
const _hoisted_3 = {
  class: "as-match-list",
  style: {"padding-top":"12px"}
}

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import MatchItemSkeleton from "~src/components/skeleton/result-popup/MatchItemSkeleton.vue";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";

const __default__ = {};

interface IProps { }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hListSkeleton',
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-h2h as-parent-h2h-${siteName.value}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
        return _createElementVNode("div", { key: index }, [
          _createVNode(SkeletonLoader, {
            width: "65px",
            height: "30px",
            line: 1
          })
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (index) => {
            return _createVNode(MatchItemSkeleton, { key: index })
          }), 64))
        ])
      ])
    ])
  ], 2))
}
}

})